var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"h-full flex items-center justify-center text-center py-16"},[_c('div',[_c('span',{class:`inline-flex h-20 w-20 border-2 border-${_vm.color} text-4xl text-${_vm.color} rounded-full items-center justify-center mb-8`},[_c('i',{class:'fal '+_vm.icon})]),_c('p',[_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }